<script setup lang="ts">
defineProps<{
  isDeleting: boolean;
  disabled: boolean;
}>();

const emit = defineEmits<{
  delete: [];
}>();
</script>

<template>
  <button
    class="delete-icon"
    type="button"
    :aria-label="isDeleting ? $t('cart.details.deletingItem') : $t('cart.details.deleteItem')"
    :aria-busy="isDeleting"
    :disabled="isDeleting || disabled"
    @click="emit('delete')"
  >
    <svg
      v-if="isDeleting" class="yb-spinner" width="24" height="24" viewBox="0 0 24 24"
      fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="#e5e5e5" stroke-width="2" />
      <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="#252525" stroke-width="2" stroke-linecap="round" />
    </svg>
    <svg
      v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4.5 7.00033H19.5M17.8333 7.00033V18.667C17.8333 19.5003 17 20.3337 16.1667 20.3337H7.83333C7 20.3337 6.16667 19.5003 6.16667 18.667V7.00033M8.66667 7.00033V5.33366C8.66667 4.50033 9.5 3.66699 10.3333 3.66699H13.6667C14.5 3.66699 15.3333 4.50033 15.3333 5.33366V7.00033M10.3333 11.167V16.167M13.6667 11.167V16.167"
        stroke="#252525" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<style scoped lang="css">
.delete-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border: var(--yb-color-mediumgray) solid 1px;
  border-radius: var(--yb-radius-sm);
  background: transparent;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
